import script from "./test.vue?vue&type=script&lang=ts&setup=true"
export * from "./test.vue?vue&type=script&lang=ts&setup=true"

import "./test.vue?vue&type=style&index=0&id=5e18ebec&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e18ebec"]])

export default __exports__